export default "__VITE_ASSET__UD2NcYr0__"